// ----------------------------------------------------------------------------
// Component: Accordion
// ----------------------------------------------------------------------------
//
// Generic accordion component.
//
// Requires the following structure:
// .js-accordion__item
//     .js-accordion__button
//     .js-accordion__content
//
// When the button is clicked, 'isOpen' class is added/removed for all three
// elements.
//
// ----------------------------------------------------------------------------

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _ = require('lodash');

// Constant elements
var ACCORDION            = '.accordion';
var ACCORDION_BUTTON     = '.js-accordion__button';
var ACCORDION_ITEM       = '.js-accordion__item';
var ACCORDION_CONTENT    = '.js-accordion__content';

// Constant trigger classes
var OPEN_CLASS          = 'is-open';

module.exports = function() {
    $(document).on('click', ACCORDION_BUTTON, _.bind(accordion.click, accordion));
};

var accordion = {
    /**
     * click: Check state of the accordion item then pass on an action
     *
     * @param {Event} e
     * @return void
     */
    click: _.debounce(function(e) {

        e.preventDefault();

        // Store $this for reference
        var $this = $(e.target);

        // Store elements as an object
        var accordion = {};

        accordion.$button    = $this;
        accordion.$item      = $this.parent(ACCORDION_ITEM);
        accordion.$content   = $this.siblings(ACCORDION_CONTENT);
        accordion.isOpening  = !$this.hasClass(OPEN_CLASS);
        accordion.$container = $this.closest(ACCORDION);

        // Collapse any open sibling & children accordions if data attribute set to true
        if(accordion.$container.data('collapse-all').collapse) {
            accordion.$item.parent().find('.' + OPEN_CLASS).removeClass(OPEN_CLASS);
        }

        accordion.$item.parent().find(ACCORDION_CONTENT).css('overflow', 'hidden');

        if (accordion.isOpening) {
            accordion.$button
                .add(accordion.$item)
                .add(accordion.$content)
                .addClass(OPEN_CLASS);

            // $('html, body').animate({
            //     scrollTop: accordion.$item.offset().top - 150
            // }, 300);

            // This allows select boxes to flow out after it's opened
            setTimeout(function() {
                accordion.$content.css('overflow', 'visible');
            }, 200);
        } else {
            accordion.$button
                .add(accordion.$item)
                .add(accordion.$content)
                .removeClass(OPEN_CLASS);
        }

        return false;
    }, 200) // Debounced to prevent double triggering and overflow issues
};
